import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldFileProps {
    field: FormFieldDto;
}

export function FormFieldFile({ field }: FormFieldFileProps) {
    return <Input name={field.name} type="file" className="form-input" required={field.required} />;
}
